import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getLogo, getPolicy, getSiteName, getStyles } from '../services/Firebase'; //getPageStyles
import LanguageSelector from '../components/LanguageSelector';
const _ = require('lodash');

// @src/pages/Policy.jsx
const Policy = () => {
    const { lang } = useParams();
    const [lng, setLng] = useState(lang || 'es');
    const [datas, setDatas] = useState({});
    const [img, setImg] = useState();
    const [name, setName] = useState('IguanaGIFT');
    const [styles, setStyles] = useState({}); // para guardar estilos dinamicos recuperamos de Firestore
    const styleRef = useRef(null);

    const camelToKebab = (str) => str.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase());
    const objectToCss = (obj, useImportant = false) =>
        obj
            ? Object.entries(obj)
                .map(([k, v]) => `${camelToKebab(k)}:${String(v)}${useImportant ? " !important" : ""};`)
                .join(" ")
            : "";

    useEffect(() => {
        async function initData() {
            setImg(await getLogo());
            setName(await getSiteName());
            setStyles(await getStyles());
            // setStyles(await getPageStyles("policy-styles", "default")); // si tuvieramos estilos para cada plantilla 
        }
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getData(lng);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lng]);

    const getData = async (lng) => {
        const ouch = _.cloneDeep(datas);
        if (ouch[lng] == null || ouch[lng].length <= 0) {
            const policy = await getPolicy(lng);
            ouch[lng] = policy;
            setDatas(ouch);
        }
    }

    // Inyecta CSS con scope
    useEffect(() => {
        const scope = '[data-scope="policy"]';
        const clsList = Object.keys(styles || {});

        const parts = clsList
            .map((cls) => {
                const rules = objectToCss(styles[cls], true);
                if (!rules) return "";
                if (cls === "texts") {
                    // aplica al contenedor .texts y también a los p dentro si no tienen class propia
                    return `${scope} .${cls}, ${scope} .${cls} p { ${rules} }`;
                }
                return `${scope} .${cls} { ${rules} }`;
            })
            .filter(Boolean);

        if (!styleRef.current) {
            const tag = document.createElement("style");
            tag.setAttribute("data-owner", "dynamic-styles-from-fb");
            document.head.appendChild(tag);
            styleRef.current = tag;
        }
        styleRef.current.textContent = parts.join("\n");

        return () => {
            if (styleRef.current) {
                document.head.removeChild(styleRef.current);
                styleRef.current = null;
            }
        };
    }, [styles]);

    const containerStyle = styles?.container ?? { width: "100%" };
    const innerStyle = styles?.inner ?? { maxWidth: "700px", margin: "0 auto" };
    const logoWrapperStyle =
        styles?.logoWrapper ?? { textAlign: "center", paddingTop: "10px", paddingBottom: "10px" };
    const logoImgStyle = styles?.logoImg ?? { maxHeight: "200px" };

    // Concatenar todas las líneas en un bloque HTML único
    const contentHtml = datas[lng]
        ? datas[lng].lines.map((line) => line.replace(/#SITENAME#/g, name)).join('')
        : '';

    return (
        <div style={containerStyle}>
            <div style={innerStyle} data-scope="policy">
                <LanguageSelector onLanguageChange={setLng} lang={lng} />
                <div style={logoWrapperStyle}>
                    <img src={img} alt="Iguana GIFT" style={logoImgStyle} />
                </div>
                <div className="dynamic-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
            </div>
        </div>
    );
};

export default Policy;